import React, { useCallback, useState } from 'react';
import { useToast } from '../../../hooks/toast';
import Buttom from '../../forms/Buttom';
import Modal from '../Modal';
import Upload from '../../forms/Upload';
import { importStudentsCsv } from '../../../services/api';
import { Container, Bottom, Hint } from './styles';

interface IModalProps {
  isOpen: boolean;
  setIsOpen: () => void;
  clearFilter: () => void;
  lmsKey: string | null;
}

const csvFormats = [
  { extension: '.csv', types: 'text/csv,application/csv' },
];

const ModalImportStudents: React.FC<IModalProps> = ({
  isOpen,
  setIsOpen,
  clearFilter,
  lmsKey,
}) => {
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);

  const handleUpload = useCallback(
    async (files: File[]) => {
      if (!lmsKey) {
        addToast({
          title: 'Erro',
          type: 'error',
          description: 'Chave LMS não encontrada. Faça login novamente.',
        });
        return;
      }
      const file = files[0];
      if (!file) return;
      try {
        setLoading(true);
        await importStudentsCsv(lmsKey, file);
        clearFilter();
        addToast({
          title: 'Importação concluída!',
          type: 'success',
          description: 'Os alunos do arquivo foram importados.',
        });
        setIsOpen();
      } catch (error) {
        const err = error as any;
        addToast({
          title: 'Erro na importação',
          type: 'error',
          description:
            err?.response?.data?.message || 'Não foi possível importar o arquivo.',
        });
      } finally {
        setLoading(false);
      }
    },
    [lmsKey, addToast, setIsOpen, clearFilter],
  );

  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
      <Container>
        <h1>Importar Alunos</h1>
        <Hint>
          Envie um arquivo CSV com as colunas: <strong>nome</strong> (ou name),{' '}
          <strong>email</strong>, <strong>curso</strong> (ou course).
        </Hint>
        <Upload
          onUpload={handleUpload}
          formts={csvFormats}
          loading={loading}
        />
        <Bottom>
          <Buttom
            name="fechar"
            type="button"
            onClick={() => setIsOpen()}
            label="Fechar"
            outline
          />
        </Bottom>
      </Container>
    </Modal>
  );
};

export default ModalImportStudents;
